{
  "Samsung": {
    "Galaxy S8+": [
      "SM-G955"
    ],
    "Galaxy S8": [
      "SM-G950"
    ],
    "Galaxy S7": [
      "SM-G930"
    ],
    "Galaxy S7 Edge": [
      "SM-G935"
    ],
    "Galaxy Note 8": [
      "SM-N950",
      "SCV37", 
      "SC-01K"
    ],
    "Galaxy A40": [
      "SM-A405"
    ],
    "Galaxy A21": [
      "SM-A215"
    ],
    "Galaxy A15 5G": [
      "SM-A156"
    ]
  },
  "Pixel" : {
    "Pixel 2" : [
      "Pixel 2"
    ],
    "Pixel 2 XL" : [
      "Pixel 2 XL"
    ]
  },
  "HTC" : {
    "10" :[
      "HTC 10"
    ]
  },
  "Huawei" : {
    "P30" :[
      "P30"
    ],
    "P30 Pro" :[
      "P30PRO"
    ]
  },
  "LG" : {
    "LV-30" : [
      "LV30"
    ]
  },
    "Redmi" : {
    "Note 7" : [
      "Redmi Note 7"
    ],
    "Note 8 Pro" : [
      "Redmi Note 8 Pro"
    ],
    "Note 9 Pro" : [
      "Redmi Note 9 Pro"
    ],
    "Note 10 Pro" : [
      "Redmi Note 10 Pro"
    ]
  },
  "Sharp Aquos" : {
    "Sharp Aquos sense5G" : [
      "Aquos sense5G", "SHG03"
    ]
  }
}